"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _types = require("../../actions/broadcast/types");
var _types2 = require("../../actions/program/types");
var initialState = exports.initialState = _SceneLayouts.SIDE_BY_SIDE;
function sceneLayout() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  if (type === _types2.BROADCAST_SET_SCENE_LAYOUT) {
    return payload || state;
  }
  if (type === _types2.BROADCAST_SET_SCENE_LAYOUT_REAL_TIME) {
    return payload || state;
  }
  if (type === "".concat(_types.GET_BROADCAST, "_SUCCESS")) {
    var program = payload.program;
    if (program && program._id && selectedLayout(program._id)) {
      return selectedLayout(program._id);
    }
  }
  return state;
}

/**
 * @param {string} layoutId
 */
function selectedLayout(layoutId) {
  return _SceneLayouts.SceneLayouts.find(function (_ref) {
    var id = _ref.id;
    return id === layoutId;
  });
}
var _default = exports["default"] = sceneLayout;